"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPaymentServiceTransactionMetadata = exports.serializeForTransaction = exports.parseTransactionFromMetadata = exports.getProvider = exports.handlePaymentStatus = exports.checkIfFullyApproved = void 0;
const homi_shared_1 = require("@getgreenline/homi-shared");
const enums_1 = require("./enums");
const enums_2 = require("../enums");
const checkIfFullyApproved = (data, transaction) => {
    const { chargedAmount, tipAmount } = data.attributes;
    const actualChargedAmount = (chargedAmount || 0) - (tipAmount || 0);
    const isFullApproval = actualChargedAmount === transaction.amount;
    return isFullApproval;
};
exports.checkIfFullyApproved = checkIfFullyApproved;
const handlePaymentStatus = (response) => {
    switch (response.attributes.status) {
        case enums_1.PaymentStatus.CREATED:
        case enums_1.PaymentStatus.CAPTURED:
            return;
        case enums_1.PaymentStatus.REFUND_PENDING:
        case enums_1.PaymentStatus.REFUNDED:
            return;
        case enums_1.PaymentStatus.CANCELED:
            throw new Error(response.attributes.cancelReason || 'Customer canceled the payment');
        case enums_1.PaymentStatus.FAILED:
            throw new Error(response.attributes.failReason || 'Payment failed');
        case enums_1.PaymentStatus.REFUSED:
            throw new Error('Payment refused');
        default:
            throw new Error('Payment status is not updated. Please check the terminal and try again.');
    }
};
exports.handlePaymentStatus = handlePaymentStatus;
const getProvider = (paymentTypeId) => {
    const paymentTypeToProvider = new Map([
        [homi_shared_1.PaymentTypeIds.blazepay, enums_2.Provider.ADYEN],
    ]);
    return paymentTypeToProvider.get(paymentTypeId);
};
exports.getProvider = getProvider;
const parseTransactionFromMetadata = (transaction) => {
    const transactionId = null;
    if (!(transaction === null || transaction === void 0 ? void 0 : transaction.metadata))
        return transactionId;
    const provider = (0, exports.getProvider)(transaction.paymentTypeId);
    if (!provider)
        return transactionId;
    const paymentServiceResponse = JSON.parse(transaction.metadata);
    /**
     * the metadata field can contain any json string data.
     * Check if the response contains "type" attribute to ensure it's a payment-service transaction.
     */
    if (!Object.keys(paymentServiceResponse).includes('type'))
        null;
    return paymentServiceResponse || null;
};
exports.parseTransactionFromMetadata = parseTransactionFromMetadata;
const serializeForTransaction = (offlinePaymentId, transaction, terminalId, currentUserId) => {
    return {
        deviceId: terminalId,
        offlinePaymentId,
        transactionAmount: transaction.amount,
        currentShiftId: currentUserId,
    };
};
exports.serializeForTransaction = serializeForTransaction;
const isPaymentServiceTransactionMetadata = (transaction) => {
    const parsedMetadata = JSON.parse(transaction.metadata || '{}');
    if (!(parsedMetadata === null || parsedMetadata === void 0 ? void 0 : parsedMetadata.id))
        return false;
    const isOnlinePayment = (parsedMetadata === null || parsedMetadata === void 0 ? void 0 : parsedMetadata.paymentOptionId) !== undefined;
    const isPOSPayment = (parsedMetadata === null || parsedMetadata === void 0 ? void 0 : parsedMetadata.type) !== undefined && (parsedMetadata === null || parsedMetadata === void 0 ? void 0 : parsedMetadata.attributes) !== undefined;
    return isOnlinePayment || isPOSPayment;
};
exports.isPaymentServiceTransactionMetadata = isPaymentServiceTransactionMetadata;
//# sourceMappingURL=utils.js.map